import { Box, Typography } from "@mui/material";

export function PrivacyContent({ language }) {
    const isGerman = language === "de";

    const localPart = 'contact';       // left side vor @
    const domain = 'newgate.li';      // domain
    const email = `${localPart}@${domain}`;

    return (
        <Box
            sx={{
                maxHeight: "70vh",
                overflowY: "auto",
                pr: 1.5,
                "&::-webkit-scrollbar": { width: 6 },
                "&::-webkit-scrollbar-thumb": { background: "#555", borderRadius: 3 },
            }}
        >
            {isGerman ? (
                <>
                    <Typography variant="subtitle1" gutterBottom>
                        1. Verantwortlicher
                    </Typography>
                    <Typography variant="body2" paragraph>
                        <strong>Newgate AG</strong>
                        <br />
                        Alte Churerstrasse 47
                        <br />
                        9496 Balzers, Liechtenstein
                        <br />
                        E-Mail: {email}
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom>
                        2. Zweck und Umfang der Datenverarbeitung
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Es werden ausschließlich diejenigen personenbezogenen Daten verarbeitet, die für den Betrieb
                        und die Bereitstellung der Dienste erforderlich sind.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        <strong>Verarbeitete Datenarten:</strong> E-Mail-Adresse, Nutzungspräferenzen und Einstellungen,
                        technisch notwendige Daten (z. B. IP-Adresse, Browserinformationen, Logfiles).
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Rechtsgrundlagen: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) und Art. 6 Abs. 1 lit. f DSGVO
                        (berechtigtes Interesse an einem sicheren und funktionsfähigen Angebot).
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom>
                        3. Newsletter
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Zum Versand des Newsletters werden ausschließlich die hierfür erforderlichen personenbezogenen
                        Daten (z. B. E-Mail-Adresse) verarbeitet. Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung
                        nach Art. 6 Abs. 1 lit. a DSGVO.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Sie können Ihre Einwilligung jederzeit widerrufen, etwa über den Abmeldelink im Newsletter oder
                        per E-Mail an {email}. Nach Abmeldung werden die Daten gelöscht, sofern keine
                        gesetzlichen Aufbewahrungspflichten bestehen.
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom>
                        4. Hosting
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Unsere Dienste werden über <strong>Firebase</strong> (Google Cloud Platform, Google Ireland Limited,
                        Gordon House, Barrow Street, Dublin 4, Irland) gehostet. Die Verarbeitung erfolgt im Rahmen einer
                        Auftragsverarbeitung gemäß Art. 28 DSGVO. Google verarbeitet die Daten ausschließlich nach
                        unserer Weisung.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Eine Übermittlung in die USA kann nicht ausgeschlossen werden. Es bestehen entsprechende
                        Garantien gem. Art. 46 DSGVO (EU-Standardvertragsklauseln).
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom>
                        5. Speicherdauer
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Personenbezogene Daten werden nur so lange gespeichert, wie dies für die Erfüllung der jeweiligen
                        Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Technische Logdaten
                        werden regelmäßig gelöscht, sobald sie für den Betrieb nicht mehr benötigt werden.
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom>
                        6. Rechte der betroffenen Personen
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Sie haben gemäß DSGVO das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
                        Verarbeitung, Datenübertragbarkeit, Widerspruch sowie auf Widerruf erteilter Einwilligungen.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Zur Ausübung dieser Rechte genügt eine Mitteilung an {email}.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Zudem besteht ein Beschwerderecht bei der Datenschutzstelle Liechtenstein (DSS),
                        Städtle 38, Postfach 684, 9490 Vaduz, E-Mail: info.dss@llv.li.
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom>
                        7. Änderungen
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen.
                    </Typography>
                </>
            ) : (
                <>
                    <Typography variant="subtitle1" gutterBottom>
                        1. Controller
                    </Typography>
                    <Typography variant="body2" paragraph>
                        <strong>Newgate AG</strong>
                        <br />
                        Alte Churerstrasse 47
                        <br />
                        9496 Balzers, Liechtenstein
                        <br />
                        E-Mail: {email}
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom>
                        2. Purpose and Scope of Data Processing
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Only the personal data necessary for the operation and provision of our services are processed.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        <strong>Types of data processed:</strong> E-mail address, user preferences and settings, and
                        technically necessary data (e.g., IP address, browser information, log files).
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Legal basis: Art. 6 (1)(b) GDPR (performance of a contract) and Art. 6 (1)(f) GDPR (legitimate
                        interest in a secure and functional service).
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom>
                        3. Newsletter
                    </Typography>
                    <Typography variant="body2" paragraph>
                        For sending the newsletter, only the personal data required for this purpose (e.g., e-mail address)
                        are processed. Processing is based on your consent under Art. 6 (1)(a) GDPR.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        You can withdraw your consent at any time via the unsubscribe link in the newsletter or by e-mail
                        to {email}. After unsubscribing, your data will be deleted unless statutory retention
                        obligations apply.
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom>
                        4. Hosting
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Our services are hosted by <strong>Firebase</strong> (Google Cloud Platform, Google Ireland Limited,
                        Gordon House, Barrow Street, Dublin 4, Ireland). Processing is carried out under a data processing
                        agreement pursuant to Art. 28 GDPR. Google processes data solely according to our instructions.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Data transfer to the USA cannot be ruled out. Appropriate safeguards under Art. 46 GDPR (EU
                        Standard Contractual Clauses) are in place.
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom>
                        5. Data Retention
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Personal data is stored only as long as necessary for the purposes for which it is processed or as
                        required by law. Technical log data is regularly deleted once no longer needed for operation.
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom>
                        6. Rights of Data Subjects
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Under the GDPR, you have the right to access, rectification, erasure, restriction of processing,
                        data portability, objection, and withdrawal of consent.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        To exercise these rights, please contact {email}.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        You also have the right to lodge a complaint with the Liechtenstein Data Protection Authority (DSS),
                        Städtle 38, P.O. Box 684, 9490 Vaduz, E-Mail: info.dss@llv.li.
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom>
                        7. Changes
                    </Typography>
                    <Typography variant="body2" paragraph>
                        We reserve the right to update this privacy policy as needed.
                    </Typography>
                </>
            )}
        </Box>
    );
}
